// extracted by mini-css-extract-plugin
export var infoItem = "_kd-1";
export var title = "_kd-0";